/*
  Adds a "Standard shipping $5.99" row to the qikify Slide Cart, directly above
  Subtotal, with no address form.

  Why: qikify's own "Estimate shipping rates" makes the customer fill in
  country/state/ZIP, because it calls Shopify's rates API which requires an
  address. This store's domestic shipping is purely price-based, so the rate is
  derivable from the cart total alone.

  Why not query Shopify live: /cart/shipping_rates.json omits this store's
  "Free Shipping (3-4 Days)" rate — a $112 cart returned only Standard $12.99,
  while real orders over $75 (#13632, #13633) were charged $0.00. Using it
  would understate the customer's benefit.

  TIERS mirror Settings > Shipping and delivery. If Brian changes rates there,
  update them here and in snippets/shipping-estimator.liquid.

  Also adds, for US carts, an "Estimated delivery  Oct 7 – Oct 9" row under
  the shipping row.

  Why the dates are computed here: Shopify's delivery dates are enabled on the
  store, but they only render at checkout once there is an address; nothing
  exposes them to the cart. The estimate is today + HANDLING + the tier's
  transit, counted in business days (weekends skipped, holidays not). Transit
  comes from the rate itself ("Free Shipping (3-4 Days)"; Standard is
  Shopify's 3-4 business day preset). Economy has no stated transit time, so
  it gets no estimate.
*/
(function () {
  var TIERS = [
    { min: 7500, label: 'Shipping', value: 'FREE', free: true, transit: [3, 4] },
    { min: 4600, label: 'Standard shipping', value: '$12.99', transit: [3, 4] },
    { min: 1000, label: 'Standard shipping', value: '$5.99', transit: [3, 4] },
    { min: 100, label: 'Economy shipping', value: '$4.85' }
  ];

  // Business days between the order and it leaving the warehouse.
  var HANDLING = [1, 2];
  var MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

  var ROW_CLASS = 'fm-shipping-row';
  var DELIVERY_CLASS = 'fm-delivery-row';

  // The rates above are the domestic zone; other countries are carrier-calculated.
  function isDomestic() {
    var country = window.Shopify && window.Shopify.country;
    return !country || country === 'US';
  }

  function addBusinessDays(from, days) {
    var d = new Date(from.getTime());
    while (days > 0) {
      d.setDate(d.getDate() + 1);
      if (d.getDay() !== 0 && d.getDay() !== 6) days--;
    }
    return d;
  }

  function deliveryText(transit) {
    var now = new Date();
    var first = addBusinessDays(now, HANDLING[0] + transit[0]);
    var last = addBusinessDays(now, HANDLING[1] + transit[1]);
    return MONTHS[first.getMonth()] + ' ' + first.getDate() + ' \u2013 ' + MONTHS[last.getMonth()] + ' ' + last.getDate();
  }

  function setText(el, text) {
    if (el.textContent !== text) el.textContent = text;
  }

  function tierFor(cents) {
    for (var i = 0; i < TIERS.length; i++) {
      if (cents >= TIERS[i].min) return TIERS[i];
    }
    return null;
  }

  function centsFromText(text) {
    var m = (text || '').replace(/,/g, '').match(/([\d]+)\.(\d{2})/);
    return m ? parseInt(m[1], 10) * 100 + parseInt(m[2], 10) : null;
  }

  function sync() {
    var summary = document.querySelector('.qsc2-drawer-footer__summary');
    if (!summary) return;

    var subtotalRow = summary.querySelector('.qsc2-drawer-footer__summary-subtotal');
    if (!subtotalRow) return;

    var priceEl = subtotalRow.querySelector('.qsc2-drawer-footer__summary-subtotal-price');
    var cents = centsFromText(priceEl && priceEl.textContent);
    if (cents === null) return;

    var info = tierFor(cents);
    var row = summary.querySelector('.' + ROW_CLASS);
    var delivery = summary.querySelector('.' + DELIVERY_CLASS);

    if (!info) {
      if (row) row.remove();
      if (delivery) delivery.remove();
      return;
    }

    if (!row) {
      row = document.createElement('div');
      // Reuse qikify's row class so it inherits their spacing and typography.
      row.className = 'qsc2-drawer-footer__row ' + ROW_CLASS;
      row.innerHTML = '<div><span class="' + ROW_CLASS + '__label"></span></div>' +
        '<div class="' + ROW_CLASS + '__value"></div>';
      subtotalRow.parentNode.insertBefore(row, subtotalRow);
    }

    setText(row.querySelector('.' + ROW_CLASS + '__label'), info.label);
    setText(row.querySelector('.' + ROW_CLASS + '__value'), info.value);
    row.classList.toggle(ROW_CLASS + '--free', !!info.free);

    var showDelivery = isDomestic() && !!info.transit;

    if (showDelivery) {
      if (!delivery) {
        delivery = document.createElement('div');
        delivery.className = 'qsc2-drawer-footer__row ' + DELIVERY_CLASS;
        delivery.innerHTML = '<div><span class="' + ROW_CLASS + '__label">Estimated delivery</span></div>' +
          '<div class="' + ROW_CLASS + '__value"></div>';
        subtotalRow.parentNode.insertBefore(delivery, subtotalRow);
      }
      setText(delivery.querySelector('.' + ROW_CLASS + '__value'), deliveryText(info.transit));
    } else if (delivery) {
      delivery.remove();
    }
    // The hairline above Subtotal belongs to whichever row is last.
    row.classList.toggle(ROW_CLASS + '--joined', showDelivery);
  }

  function boot() {
    sync();
    // qikify re-renders its drawer on every cart change.
    new MutationObserver(function () { sync(); })
      .observe(document.documentElement, { childList: true, subtree: true, characterData: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
